import sDocumentAxios from "./statistic-documents.service";

export interface Employee {
  employeeCode: string;
  employeeName: string;
  employeeEmail: string;
  departmentId?: number;
  departmentCode: string;
  departmentName: string;
  acceptUpdate: boolean;
  email?: string;
}

export type DataResponse = {
  statusCode: number;
  message: string;
  totalRecord: number;
  data: boolean | null;
};

export interface NonEmailUserResponse {
  id: string;
  employeeCode: string;
  employeeName: string;
  unit: string;
  department: string;
  read: boolean;
  note: string;
}


export class EmployeeService {
  static async getEmployeeListV5(departmentId: string, employeeIds: string[] = []) {
    const { data } = await sDocumentAxios.post(
      `/viagsemployee/get-list-employee-by-departmentid/${departmentId}`,
      employeeIds,
    );
    return data.data;
  }

  static async getEmployeeList(departmentCode: string) {
    try {
      const res = await sDocumentAxios.get<{ data: Employee[]; statusCode: number }>(
        "/viagsemployee/get-list-employee-by-departmentcode",
        { params: { departmentCode } },
      );
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async getEmployeeListHasEmail() {
    try {
      const res = await sDocumentAxios.get<{ data: Employee[]; statusCode: number }>(
        "/viagsemployee/get-list-employee-have-email",
      );
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async addEmployee(fields: any) {
    try {
      const res = await sDocumentAxios.post("/viagsemployee/add", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateEmployee(fields: any) {
    try {
      const res = await sDocumentAxios.post("/viagsemployee/update", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async deleteEmployee(fields: any) {
    try {
      const res = await sDocumentAxios.post("/viagsemployee/delete", fields);
      if (res.data.statusCode !== 200) return res;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async checkGroupUser(email: string): Promise<boolean> {
    try {
      const res = await sDocumentAxios.post(`/viagsemployee/check-group-user/${email}`);
      if (res.data.statusCode !== 200) return false;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  }

  static async getListNoneEmail(groupEmails: string[]): Promise<NonEmailUserResponse[] | []>
  {
    try {
      const res = await sDocumentAxios.post(`/viagsemployee/get-list-none-email-user-in-group-account`, groupEmails);
      if (res.data.statusCode !== 200) return [];
      return res.data.data;
    } catch (error: any) {
      console.log(error);
      return [];
    }
  }
}
